import { createAsyncThunk } from '@reduxjs/toolkit';
import { createCompanyPositionsRequest, deleteCompanyPositionsRequest, getCompanyPositionsRequest, updateCompanyPositionsRequest } from '../../../../signature-api';

export const getCompanyPositions = createAsyncThunk('company/positions', async () => {

  return await getCompanyPositionsRequest();
});

export const createCompanyPositions = createAsyncThunk('company/createPositions', async (companyPosition) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const company = userData.Company;
  return await createCompanyPositionsRequest({...companyPosition, companyId: Number(company)});
});

export const updateCompanyPositions = createAsyncThunk('company/updatePositions', async (companyPosition) => {
  const userDataString = localStorage.getItem('userData');
  const userData = JSON.parse(userDataString);
  const company = userData.Company;
  return await updateCompanyPositionsRequest({...companyPosition, companyId: Number(company)});
});

export const deleteCompanyPositions = createAsyncThunk('company/deletePositions', async (companyPositionId) => {
  try {

    return await deleteCompanyPositionsRequest(companyPositionId);
  } catch (e) {
    console.log("Error ", e)
  }
});